var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.titledActions
    ? _c(
        "div",
        {
          staticClass: "mega-menu-button-region",
          class: _vm.moreThanOne(_vm.content),
        },
        _vm._l(_vm.content, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "banner-action-item" },
            [
              item.linkTitle && item.linkUrl
                ? _c("HighlightButton", {
                    attrs: {
                      "button-type": item.buttonType,
                      "button-size": item.buttonSize,
                      "button-style": item.buttonStyle,
                      url: item.linkUrl,
                      title: item.linkTitle,
                      "url-new-window": item.linkTarget,
                      block: "",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }